module.exports = __webpack_public_path__ + "img/ja.75bd3e3.png";